// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

/* the main calendar container theme */

/*.fc { !* the main calendar container *!*/
/*    background-color: #1f2023;*/
/*    color: #ecf0f1;*/
/*}*/

/*.fc-daygrid-day { !* the individual day cells *!*/
/*    background-color: #1d2731;*/
/*}*/

/*.fc-event { !* the events *!*/
/*    background-color: #3498db;*/
/*    border-color: #3498db;*/
/*}*/

/*.ql-toolbar.ql-snow {*/
/*    border: 1px solid #fff;*/
/*    border-top-right-radius: 0.5rem;*/
/*    border-top-left-radius: 0.5rem;*/
/*    box-sizing: border-box;*/
/*    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;*/
/*    padding: 8px;*/
/*    background-color: white;*/
/*}*/

.fc {
    height: 90vh !important;
    width: 100% !important;
}

.bg-primary {
  background-color: #5e72e4 !important;
}

.bg-secondary {
  background-color: #8392ab !important;
}

.bg-success {
  background-color: #2dce89 !important;
}

.bg-info {
  background-color: #11cdef !important;
}

.bg-warning {
  background-color: #fb6340 !important;
}

.bg-danger {
  background-color: #f5365c !important;
}

.bg-light {
  background-color: #e9ecef !important;
}

.bg-dark {
  background-color: #344767 !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-body {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.bg-gray-100 {
  background-color: #f8f9fa !important;
}

.bg-gray-200 {
  background-color: #e9ecef !important;
}

.bg-gray-300 {
  background-color: #dee2e6 !important;
}

.bg-gray-400 {
  background-color: #ced4da !important;
}

.bg-gray-500 {
  background-color: #adb5bd !important;
}

.bg-gray-600 {
  background-color: #6c757d !important;
}

.bg-gray-700 {
  background-color: #495057 !important;
}

.bg-gray-800 {
  background-color: #343a40 !important;
}

.bg-gray-900 {
  background-color: #212529 !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.bg-gradient-primary {
  background-image: linear-gradient(310deg, #5e72e4 0%, #825ee4 100%);
}

.bg-gradient-secondary {
  background-image: linear-gradient(310deg, #627594 0%, #a8b8d8 100%);
}

.bg-gradient-success {
  background-image: linear-gradient(310deg, #2dce89 0%, #2dcecc 100%);
}

.bg-gradient-info {
  background-image: linear-gradient(310deg, #1171ef 0%, #11cdef 100%);
}

.bg-gradient-warning {
  background-image: linear-gradient(310deg, #fb6340 0%, #fbb140 100%);
}

.bg-gradient-danger {
  background-image: linear-gradient(310deg, #f5365c 0%, #f56036 100%);
}

.bg-gradient-light {
  background-image: linear-gradient(310deg, #CED4DA 0%, #EBEFF4 100%);
}

.bg-gradient-dark {
  background-image: linear-gradient(310deg, #212229 0%, #212529 100%);
}

.bg-gradient-faded-primary {
  background-image: radial-gradient(370px circle at 80% 50%, rgba(94, 114, 228, 0.6) 0, #324cdd 100%);
}

.bg-gradient-faded-secondary {
  background-image: radial-gradient(370px circle at 80% 50%, rgba(131, 146, 171, 0.6) 0, #657796 100%);
}

.bg-gradient-faded-success {
  background-image: radial-gradient(370px circle at 80% 50%, rgba(45, 206, 137, 0.6) 0, #24a46d 100%);
}

.bg-gradient-faded-info {
  background-image: radial-gradient(370px circle at 80% 50%, rgba(17, 205, 239, 0.6) 0, #0da5c0 100%);
}

.bg-gradient-faded-warning {
  background-image: radial-gradient(370px circle at 80% 50%, rgba(251, 99, 64, 0.6) 0, #fa3a0e 100%);
}

.bg-gradient-faded-danger {
  background-image: radial-gradient(370px circle at 80% 50%, rgba(245, 54, 92, 0.6) 0, #ec0c38 100%);
}

.bg-gradient-faded-light {
  background-image: radial-gradient(370px circle at 80% 50%, rgba(233, 236, 239, 0.6) 0, #cbd3da 100%);
}

.bg-gradient-faded-dark {
  background-image: radial-gradient(370px circle at 80% 50%, rgba(52, 71, 103, 0.6) 0, #233045 100%);
}

.bg-gradient-faded-white {
  background-image: radial-gradient(370px circle at 80% 50%, rgba(255, 255, 255, 0.6) 0, #e6e6e6 100%);
}

.bg-gradient-faded-primary-vertical {
  background-image: radial-gradient(200px circle at 50% 70%, rgba(94, 114, 228, 0.3) 0, #5e72e4 100%);
}

.bg-gradient-faded-secondary-vertical {
  background-image: radial-gradient(200px circle at 50% 70%, rgba(131, 146, 171, 0.3) 0, #8392ab 100%);
}

.bg-gradient-faded-success-vertical {
  background-image: radial-gradient(200px circle at 50% 70%, rgba(45, 206, 137, 0.3) 0, #2dce89 100%);
}

.bg-gradient-faded-info-vertical {
  background-image: radial-gradient(200px circle at 50% 70%, rgba(17, 205, 239, 0.3) 0, #11cdef 100%);
}

.bg-gradient-faded-warning-vertical {
  background-image: radial-gradient(200px circle at 50% 70%, rgba(251, 99, 64, 0.3) 0, #fb6340 100%);
}

.bg-gradient-faded-danger-vertical {
  background-image: radial-gradient(200px circle at 50% 70%, rgba(245, 54, 92, 0.3) 0, #f5365c 100%);
}

.bg-gradient-faded-light-vertical {
  background-image: radial-gradient(200px circle at 50% 70%, rgba(233, 236, 239, 0.3) 0, #e9ecef 100%);
}

.bg-gradient-faded-dark-vertical {
  background-image: radial-gradient(200px circle at 50% 70%, rgba(52, 71, 103, 0.3) 0, #344767 100%);
}

.bg-gradient-faded-white-vertical {
  background-image: radial-gradient(200px circle at 50% 70%, rgba(255, 255, 255, 0.3) 0, #fff 100%);
}

.bg-primary-soft {
  background: rgba(94, 114, 228, 0.03);
}

.bg-info-soft {
  background: rgba(17, 113, 239, 0.03);
}

.bg-success-soft {
  background: rgba(45, 206, 137, 0.03);
}

.bg-warning-soft {
  background: rgba(251, 99, 64, 0.03);
}

.bg-danger-soft {
  background: rgba(245, 54, 92, 0.03);
}

/*!
FullCalendar v5.6.0
Docs & License: https://fullcalendar.io/
(c) 2020 Adam Shaw
*/
/* classes attached to <body> */
/* classes attached to <body> */
.fc-not-allowed,
.fc-not-allowed .fc-event {
  /* override events' custom cursors */
  cursor: not-allowed;
}

.fc-unselectable {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.fc {
  /* layout of immediate children */
  display: flex;
  flex-direction: column;
  font-size: 1em;
}

.fc,
.fc *,
.fc *:before,
.fc *:after {
  box-sizing: border-box;
}

.fc table {
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 1em;
  /* normalize cross-browser */
}

.fc th {
  text-align: center;
}

.fc th,
.fc td {
  vertical-align: top;
  padding: 0;
}

.fc a[data-navlink] {
  cursor: pointer;
}

.fc a[data-navlink]:hover {
  text-decoration: underline;
}

.fc-direction-ltr {
  direction: ltr;
  text-align: left;
}

.fc-direction-rtl {
  direction: rtl;
  text-align: right;
}

.fc-theme-standard td,
.fc-theme-standard th {
  border: 1px solid #ddd;
  border: 1px solid var(--fc-border-color, #ddd);
}

/* for FF, which doesn't expand a 100% div within a table cell. use absolute positioning */
/* inner-wrappers are responsible for being absolute */
/* TODO: best place for this? */
.fc-liquid-hack td,
.fc-liquid-hack th {
  position: relative;
}

@font-face {
  font-family: 'fcicons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

.fc-icon {
  /* added for fc */
  display: inline-block;
  width: 1em;
  height: 1em;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'fcicons' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fc-icon-chevron-left:before {
  content: "\\e900";
}

.fc-icon-chevron-right:before {
  content: "\\e901";
}

.fc-icon-chevrons-left:before {
  content: "\\e902";
}

.fc-icon-chevrons-right:before {
  content: "\\e903";
}

.fc-icon-minus-square:before {
  content: "\\e904";
}

.fc-icon-plus-square:before {
  content: "\\e905";
}

.fc-icon-x:before {
  content: "\\e906";
}

/*
Lots taken from Flatly (MIT): https://bootswatch.com/4/flatly/bootstrap.css

These styles only apply when the standard-theme is activated.
When it's NOT activated, the fc-button classes won't even be in the DOM.
*/
.fc {
  /* reset */
}

.fc .fc-button {
  border-radius: 0;
  overflow: visible;
  text-transform: none;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.fc .fc-button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

.fc .fc-button {
  -webkit-appearance: button;
}

.fc .fc-button:not(:disabled) {
  cursor: pointer;
}

.fc .fc-button::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

.fc {
  /* theme */
}

.fc .fc-button {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.4em 0.65em;
  font-size: 1em;
  line-height: 1.5;
  border-radius: 0.25em;
}

.fc .fc-button:hover {
  text-decoration: none;
}

.fc .fc-button:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(44, 62, 80, 0.25);
}

.fc .fc-button:disabled {
  opacity: 0.65;
}

.fc {
  /* "primary" coloring */
}

.fc .fc-button-primary {
  color: #fff;
  color: var(--fc-button-text-color, #fff);
  background-color: #2C3E50;
  background-color: var(--fc-button-bg-color, #2C3E50);
  border-color: #2C3E50;
  border-color: var(--fc-button-border-color, #2C3E50);
}

.fc .fc-button-primary:hover {
  color: #fff;
  color: var(--fc-button-text-color, #fff);
  background-color: #1e2b37;
  background-color: var(--fc-button-hover-bg-color, #1e2b37);
  border-color: #1a252f;
  border-color: var(--fc-button-hover-border-color, #1a252f);
}

.fc .fc-button-primary:disabled {
  /* not DRY */
  color: #fff;
  color: var(--fc-button-text-color, #fff);
  background-color: #2C3E50;
  background-color: var(--fc-button-bg-color, #2C3E50);
  border-color: #2C3E50;
  border-color: var(--fc-button-border-color, #2C3E50);
  /* overrides :hover */
}

.fc .fc-button-primary:focus {
  box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);
}

.fc .fc-button-primary:not(:disabled):active,
.fc .fc-button-primary:not(:disabled).fc-button-active {
  color: #fff;
  color: var(--fc-button-text-color, #fff);
  background-color: #1a252f;
  background-color: var(--fc-button-active-bg-color, #1a252f);
  border-color: #151e27;
  border-color: var(--fc-button-active-border-color, #151e27);
}

.fc .fc-button-primary:not(:disabled):active:focus,
.fc .fc-button-primary:not(:disabled).fc-button-active:focus {
  box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);
}

.fc {
  /* icons within buttons */
}

.fc .fc-button .fc-icon {
  vertical-align: middle;
  font-size: 1.5em;
  /* bump up the size (but don't make it bigger than line-height of button, which is 1.5em also) */
}

.fc .fc-button-group {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.fc .fc-button-group>.fc-button {
  position: relative;
  flex: 1 1 auto;
}

.fc .fc-button-group>.fc-button:hover {
  z-index: 1;
}

.fc .fc-button-group>.fc-button:focus,
.fc .fc-button-group>.fc-button:active,
.fc .fc-button-group>.fc-button.fc-button-active {
  z-index: 1;
}

.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child) {
  margin-right: -1px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.fc .fc-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.fc .fc-toolbar.fc-header-toolbar {
  margin-bottom: 1.5em;
}

.fc .fc-toolbar.fc-footer-toolbar {
  margin-top: 1.5em;
}

.fc .fc-toolbar-title {
  font-size: 1.75em;
  margin: 0;
}

.fc-direction-ltr .fc-toolbar>*> :not(:first-child) {
  margin-left: .75em;
  /* space between */
}

.fc-direction-rtl .fc-toolbar>*> :not(:first-child) {
  margin-right: .75em;
  /* space between */
}

.fc-direction-rtl .fc-toolbar-ltr {
  /* when the toolbar-chunk positioning system is explicitly left-to-right */
  flex-direction: row-reverse;
}

.fc .fc-scroller {
  -webkit-overflow-scrolling: touch;
  position: relative;
  /* for abs-positioned elements within */
}

.fc .fc-scroller-liquid {
  height: 100%;
}

.fc .fc-scroller-liquid-absolute {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}

.fc .fc-scroller-harness {
  position: relative;
  overflow: hidden;
  direction: ltr;
  /* hack for chrome computing the scroller's right/left wrong for rtl. undone below... */
  /* TODO: demonstrate in codepen */
}

.fc .fc-scroller-harness-liquid {
  height: 100%;
}

.fc-direction-rtl .fc-scroller-harness>.fc-scroller {
  /* undo above hack */
  direction: rtl;
}

.fc-theme-standard .fc-scrollgrid {
  border: 1px solid #ddd;
  border: 1px solid var(--fc-border-color, #ddd);
  /* bootstrap does this. match */
}

.fc .fc-scrollgrid,
.fc .fc-scrollgrid table {
  /* all tables (self included) */
  width: 100%;
  /* because tables don't normally do this */
  table-layout: fixed;
}

.fc .fc-scrollgrid table {
  /* inner tables */
  border-top-style: hidden;
  border-left-style: hidden;
  border-right-style: hidden;
}

.fc .fc-scrollgrid {
  border-collapse: separate;
  border-right-width: 0;
  border-bottom-width: 0;
}

.fc .fc-scrollgrid-liquid {
  height: 100%;
}

.fc .fc-scrollgrid-section {
  /* a <tr> */
  height: 1px;
}

.fc .fc-scrollgrid-section>td {
  height: 1px;
  /* needs a height so inner div within grow. better than 0, for firefox */
}

.fc .fc-scrollgrid-section table {
  height: 1px;
  /* for most browsers, if a height isn't set on the table, can't do liquid-height within cells */
  /* serves as a min-height. harmless */
}

.fc .fc-scrollgrid-section-liquid {
  height: auto;
}

.fc .fc-scrollgrid-section-liquid>td {
  height: 100%;
  /* better than \`auto\`, for firefox */
}

.fc .fc-scrollgrid-section>* {
  border-top-width: 0;
  border-left-width: 0;
}

.fc .fc-scrollgrid-section-header>*,
.fc .fc-scrollgrid-section-footer>* {
  border-bottom-width: 0;
}

.fc .fc-scrollgrid-section-body table,
.fc .fc-scrollgrid-section-footer table {
  border-bottom-style: hidden;
  /* head keeps its bottom border tho */
}

.fc {
  /* stickiness */
}

.fc .fc-scrollgrid-section-sticky>* {
  background: #fff;
  background: var(--fc-page-bg-color, #fff);
  position: -webkit-sticky;
  position: sticky;
  z-index: 2;
  /* TODO: var */
  /* TODO: box-shadow when sticking */
}

.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>* {
  top: 0;
  /* because border-sharing causes a gap at the top */
  /* TODO: give safari -1. has bug */
}

.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>* {
  bottom: 0;
  /* known bug: bottom-stickiness doesn't work in safari */
}

.fc .fc-scrollgrid-sticky-shim {
  /* for horizontal scrollbar */
  height: 1px;
  /* needs height to create scrollbars */
  margin-bottom: -1px;
}

.fc-sticky {
  /* no .fc wrap because used as child of body */
  position: -webkit-sticky;
  position: sticky;
}

.fc .fc-view-harness {
  flex-grow: 1;
  /* because this harness is WITHIN the .fc's flexbox */
  position: relative;
}

.fc {
  /* when the harness controls the height, make the view liquid */
}

.fc .fc-view-harness-active>.fc-view {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.fc .fc-col-header-cell-cushion {
  display: inline-block;
  /* x-browser for when sticky (when multi-tier header) */
  padding: 2px 4px;
}

.fc .fc-bg-event,
.fc .fc-non-business,
.fc .fc-highlight {
  /* will always have a harness with position:relative/absolute, so absolutely expand */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.fc .fc-non-business {
    background: rgba(215, 215, 215, 0.3);
    background: hsl(0deg 0% 0% / 81%);
}

.fc .fc-bg-event {
  background: #8fdf82;
  background: var(--fc-bg-event-color, #8fdf82);
  opacity: 0.3;
  opacity: var(--fc-bg-event-opacity, 0.3);
}

.fc .fc-bg-event .fc-event-title {
  margin: .5em;
  font-size: .85em;
  font-size: var(--fc-small-font-size, 0.85em);
  font-style: italic;
}

.fc .fc-highlight {
  background: rgba(188, 232, 241, 0.3);
  background: var(--fc-highlight-color, rgba(188, 232, 241, 0.3));
}

.fc .fc-cell-shaded,
.fc .fc-day-disabled {
  background: rgba(208, 208, 208, 0.3);
  background: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));
}

/* link resets */
/* ---------------------------------------------------------------------------------------------------- */
a.fc-event,
a.fc-event:hover {
  text-decoration: none;
}

/* cursor */
.fc-event[href],
.fc-event.fc-event-draggable {
  cursor: pointer;
}

/* event text content */
/* ---------------------------------------------------------------------------------------------------- */
.fc-event .fc-event-main {
  position: relative;
  z-index: 2;
}

/* dragging */
/* ---------------------------------------------------------------------------------------------------- */
.fc-event-dragging:not(.fc-event-selected) {
  /* MOUSE */
  opacity: 0.75;
}

.fc-event-dragging.fc-event-selected {
  /* TOUCH */
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.3);
}

/* resizing */
/* ---------------------------------------------------------------------------------------------------- */
/* (subclasses should hone positioning for touch and non-touch) */
.fc-event .fc-event-resizer {
  display: none;
  position: absolute;
  z-index: 4;
}

.fc-event:hover,
.fc-event-selected {
  /* TOUCH */
}

.fc-event:hover .fc-event-resizer,
.fc-event-selected .fc-event-resizer {
  display: block;
}

.fc-event-selected .fc-event-resizer {
  border-radius: 4px;
  border-radius: calc(var(--fc-event-resizer-dot-total-width, 8px) / 2);
  border-width: 1px;
  border-width: var(--fc-event-resizer-dot-border-width, 1px);
  width: 8px;
  width: var(--fc-event-resizer-dot-total-width, 8px);
  height: 8px;
  height: var(--fc-event-resizer-dot-total-width, 8px);
  border-style: solid;
  border-color: inherit;
  background: #fff;
  background: var(--fc-page-bg-color, #fff);
}

.fc-event-selected .fc-event-resizer:before {
  content: '';
  position: absolute;
  top: -20px;
  left: -20px;
  right: -20px;
  bottom: -20px;
}

/* selecting (always TOUCH) */
/* ---------------------------------------------------------------------------------------------------- */
.fc-event-selected {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.fc-event-selected:before {
  content: "";
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.fc-event-selected {
  /* dimmer effect */
}

.fc-event-selected:after {
  content: "";
  background: rgba(0, 0, 0, 0.25);
  background: var(--fc-event-selected-overlay-color, rgba(0, 0, 0, 0.25));
  position: absolute;
  z-index: 1;
  /* assume there's a border on all sides. overcome it. */
  /* sometimes there's NOT a border, in which case the dimmer will go over */
  /* an adjacent border, which looks fine. */
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
}

/*
A HORIZONTAL event
*/
.fc-h-event {
  /* allowed to be top-level */
  display: block;
  border: 1px solid #3788d8;
  border: 1px solid var(--fc-event-border-color, #3788d8);
  background-color: #3788d8;
  background-color: var(--fc-event-bg-color, #3788d8);
}

.fc-h-event .fc-event-main {
  color: #fff;
  color: var(--fc-event-text-color, #fff);
}

.fc-h-event .fc-event-main-frame {
  display: flex;
  /* for make fc-event-title-container expand */
}

.fc-h-event .fc-event-time {
  max-width: 100%;
  /* clip overflow on this element */
  overflow: hidden;
}

.fc-h-event .fc-event-title-container {
  /* serves as a container for the sticky cushion */
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  /* important for allowing to shrink all the way */
}

.fc-h-event .fc-event-title {
  display: inline-block;
  /* need this to be sticky cross-browser */
  vertical-align: top;
  /* for not messing up line-height */
  left: 0;
  /* for sticky */
  right: 0;
  /* for sticky */
  max-width: 100%;
  /* clip overflow on this element */
  overflow: hidden;
}

.fc-h-event.fc-event-selected:before {
  /* expand hit area */
  top: -10px;
  bottom: -10px;
}

/* adjust border and border-radius (if there is any) for non-start/end */
.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),
.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left-width: 0;
}

.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),
.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right-width: 0;
}

/* resizers */
.fc-h-event:not(.fc-event-selected) .fc-event-resizer {
  top: 0;
  bottom: 0;
  width: 8px;
  width: var(--fc-event-resizer-thickness, 8px);
}

.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,
.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end {
  cursor: w-resize;
  left: -4px;
  left: calc(var(--fc-event-resizer-thickness, 8px) / -2);
}

.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,
.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start {
  cursor: e-resize;
  right: -4px;
  right: calc(var(--fc-event-resizer-thickness, 8px) / -2);
}

/* resizers for TOUCH */
.fc-h-event.fc-event-selected .fc-event-resizer {
  top: 50%;
  margin-top: -4px;
  margin-top: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,
.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end {
  left: -4px;
  left: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,
.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start {
  right: -4px;
  right: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

:root {
  --fc-daygrid-event-dot-width: 8px;
}

.fc .fc-popover {
  position: fixed;
  top: 0;
  /* for when not positioned yet */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.fc .fc-popover-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 3px 4px;
}

.fc .fc-popover-title {
  margin: 0 2px;
}

.fc .fc-popover-close {
  cursor: pointer;
  opacity: 0.65;
  font-size: 1.1em;
}

.fc-theme-standard .fc-popover {
  border: 1px solid #ddd;
  border: 1px solid var(--fc-border-color, #ddd);
  background: #fff;
  background: var(--fc-page-bg-color, #fff);
}

.fc-theme-standard .fc-popover-header {
  background: rgba(208, 208, 208, 0.3);
  background: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));
}

/* help things clear margins of inner content */
.fc-daygrid-day-frame,
.fc-daygrid-day-events,
.fc-daygrid-event-harness {
  /* for event top/bottom margins */
}

.fc-daygrid-day-frame:before,
.fc-daygrid-day-events:before,
.fc-daygrid-event-harness:before {
  content: "";
  clear: both;
  display: table;
}

.fc-daygrid-day-frame:after,
.fc-daygrid-day-events:after,
.fc-daygrid-event-harness:after {
  content: "";
  clear: both;
  display: table;
}

.fc .fc-daygrid-body {
  /* a <div> that wraps the table */
  position: relative;
  z-index: 1;
  /* container inner z-index's because <tr>s can't do it */
}

.fc .fc-daygrid-day.fc-day-today {
  background-color: rgba(255, 220, 40, 0.15);
  background-color: var(--fc-today-bg-color, rgba(255, 220, 40, 0.15));
}

.fc .fc-daygrid-day-frame {
  position: relative;
  min-height: 100%;
  /* seems to work better than \`height\` because sets height after rows/cells naturally do it */
}

.fc {
  /* cell top */
}

.fc .fc-daygrid-day-top {
  display: flex;
  flex-direction: row-reverse;
}

.fc .fc-day-other .fc-daygrid-day-top {
  opacity: 0.3;
}

.fc {
  /* day number (within cell top) */
}

.fc .fc-daygrid-day-number {
  position: relative;
  z-index: 4;
  padding: 4px;
}

.fc {
  /* event container */
}

.fc .fc-daygrid-day-events {
  margin-top: 1px;
  /* needs to be margin, not padding, so that available cell height can be computed */
}

.fc {
  /* positioning for balanced vs natural */
}

.fc .fc-daygrid-body-balanced .fc-daygrid-day-events {
  position: absolute;
  left: 0;
  right: 0;
}

.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events {
  position: relative;
  /* for containing abs positioned event harnesses */
  min-height: 2em;
  /* in addition to being a min-height during natural height, equalizes the heights a little bit */
}

.fc .fc-daygrid-body-natural {
  /* can coexist with -unbalanced */
}

.fc .fc-daygrid-body-natural .fc-daygrid-day-events {
  margin-bottom: 1em;
}

.fc {
  /* event harness */
}

.fc .fc-daygrid-event-harness {
  position: relative;
}

.fc .fc-daygrid-event-harness-abs {
  position: absolute;
  top: 0;
  /* fallback coords for when cannot yet be computed */
  left: 0;
  /* */
  right: 0;
  /* */
}

.fc .fc-daygrid-bg-harness {
  position: absolute;
  top: 0;
  bottom: 0;
}

.fc {
  /* bg content */
}

.fc .fc-daygrid-day-bg .fc-non-business {
  z-index: 1;
}

.fc .fc-daygrid-day-bg .fc-bg-event {
  z-index: 2;
}

.fc .fc-daygrid-day-bg .fc-highlight {
  z-index: 3;
}

.fc {
  /* events */
}

.fc .fc-daygrid-event {
  z-index: 6;
  margin-top: 1px;
}

.fc .fc-daygrid-event.fc-event-mirror {
  z-index: 7;
}

.fc {
  /* cell bottom (within day-events) */
}

.fc .fc-daygrid-day-bottom {
  font-size: .85em;
  margin: 2px 3px 0;
}

.fc .fc-daygrid-more-link {
  position: relative;
  z-index: 4;
  cursor: pointer;
}

.fc {
  /* week number (within frame) */
}

.fc .fc-daygrid-week-number {
  position: absolute;
  z-index: 5;
  top: 0;
  padding: 2px;
  min-width: 1.5em;
  text-align: center;
  background-color: rgba(208, 208, 208, 0.3);
  background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));
  color: #808080;
  color: var(--fc-neutral-text-color, #808080);
}

.fc {
  /* popover */
}

.fc .fc-more-popover {
  z-index: 8;
}

.fc .fc-more-popover .fc-popover-body {
  min-width: 220px;
  padding: 10px;
}

.fc-direction-ltr .fc-daygrid-event.fc-event-start,
.fc-direction-rtl .fc-daygrid-event.fc-event-end {
  margin-left: 2px;
}

.fc-direction-ltr .fc-daygrid-event.fc-event-end,
.fc-direction-rtl .fc-daygrid-event.fc-event-start {
  margin-right: 2px;
}

.fc-direction-ltr .fc-daygrid-week-number {
  left: 0;
  border-radius: 0 0 3px 0;
}

.fc-direction-rtl .fc-daygrid-week-number {
  right: 0;
  border-radius: 0 0 0 3px;
}

.fc-liquid-hack .fc-daygrid-day-frame {
  position: static;
  /* will cause inner absolute stuff to expand to <td> */
}

.fc-daygrid-event {
  /* make root-level, because will be dragged-and-dropped outside of a component root */
  position: relative;
  /* for z-indexes assigned later */
  white-space: nowrap;
  border-radius: 3px;
  /* dot event needs this to when selected */
  font-size: .85em;
  font-size: var(--fc-small-font-size, 0.85em);
}

/* --- the rectangle ("block") style of event --- */
.fc-daygrid-block-event .fc-event-time {
  font-weight: bold;
}

.fc-daygrid-block-event .fc-event-time,
.fc-daygrid-block-event .fc-event-title {
  padding: 1px;
}

/* --- the dot style of event --- */
.fc-daygrid-dot-event {
  display: flex;
  align-items: center;
  padding: 2px 0;
}

.fc-daygrid-dot-event .fc-event-title {
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  /* important for allowing to shrink all the way */
  overflow: hidden;
  font-weight: bold;
}

.fc-daygrid-dot-event:hover,
.fc-daygrid-dot-event.fc-event-mirror {
  background: rgba(0, 0, 0, 0.1);
}

.fc-daygrid-dot-event.fc-event-selected:before {
  /* expand hit area */
  top: -10px;
  bottom: -10px;
}

.fc-daygrid-event-dot {
  /* the actual dot */
  margin: 0 4px;
  box-sizing: content-box;
  width: 0;
  height: 0;
  border: 4px solid #3788d8;
  border: calc(var(--fc-daygrid-event-dot-width, 8px) / 2) solid var(--fc-event-border-color, #3788d8);
  border-radius: 4px;
  border-radius: calc(var(--fc-daygrid-event-dot-width, 8px) / 2);
}

/* --- spacing between time and title --- */
.fc-direction-ltr .fc-daygrid-event .fc-event-time {
  margin-right: 3px;
}

.fc-direction-rtl .fc-daygrid-event .fc-event-time {
  margin-left: 3px;
}

/*
A VERTICAL event
*/
.fc-v-event {
  /* allowed to be top-level */
  display: block;
  border: 1px solid #3788d8;
  border: 1px solid var(--fc-event-border-color, #3788d8);
  background-color: #3788d8;
  background-color: var(--fc-event-bg-color, #3788d8);
}

.fc-v-event .fc-event-main {
  color: #fff;
  color: var(--fc-event-text-color, #fff);
  height: 100%;
}

.fc-v-event .fc-event-main-frame {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.fc-v-event .fc-event-time {
  flex-grow: 0;
  flex-shrink: 0;
  max-height: 100%;
  overflow: hidden;
}

.fc-v-event .fc-event-title-container {
  /* a container for the sticky cushion */
  flex-grow: 1;
  flex-shrink: 1;
  min-height: 0;
  /* important for allowing to shrink all the way */
}

.fc-v-event .fc-event-title {
  /* will have fc-sticky on it */
  top: 0;
  bottom: 0;
  max-height: 100%;
  /* clip overflow */
  overflow: hidden;
}

.fc-v-event:not(.fc-event-start) {
  border-top-width: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.fc-v-event:not(.fc-event-end) {
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.fc-v-event.fc-event-selected:before {
  /* expand hit area */
  left: -10px;
  right: -10px;
}

.fc-v-event {
  /* resizer (mouse AND touch) */
}

.fc-v-event .fc-event-resizer-start {
  cursor: n-resize;
}

.fc-v-event .fc-event-resizer-end {
  cursor: s-resize;
}

.fc-v-event {
  /* resizer for MOUSE */
}

.fc-v-event:not(.fc-event-selected) .fc-event-resizer {
  height: 8px;
  height: var(--fc-event-resizer-thickness, 8px);
  left: 0;
  right: 0;
}

.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start {
  top: -4px;
  top: calc(var(--fc-event-resizer-thickness, 8px) / -2);
}

.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end {
  bottom: -4px;
  bottom: calc(var(--fc-event-resizer-thickness, 8px) / -2);
}

.fc-v-event {
  /* resizer for TOUCH (when event is "selected") */
}

.fc-v-event.fc-event-selected .fc-event-resizer {
  left: 50%;
  margin-left: -4px;
  margin-left: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

.fc-v-event.fc-event-selected .fc-event-resizer-start {
  top: -4px;
  top: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

.fc-v-event.fc-event-selected .fc-event-resizer-end {
  bottom: -4px;
  bottom: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

.fc .fc-timegrid .fc-daygrid-body {
  /* the all-day daygrid within the timegrid view */
  z-index: 2;
  /* put above the timegrid-body so that more-popover is above everything. TODO: better solution */
}

.fc .fc-timegrid-divider {
  padding: 0 0 2px;
  /* browsers get confused when you set height. use padding instead */
}

.fc .fc-timegrid-body {
  position: relative;
  z-index: 1;
  /* scope the z-indexes of slots and cols */
  min-height: 100%;
  /* fill height always, even when slat table doesn't grow */
}

.fc .fc-timegrid-axis-chunk {
  /* for advanced ScrollGrid */
  position: relative;
}

.fc .fc-timegrid-axis-chunk>table {
  position: relative;
  z-index: 1;
  /* above the now-indicator-container */
}

.fc .fc-timegrid-slots {
  position: relative;
  z-index: 1;
}

.fc .fc-timegrid-slot {
  /* a <td> */
  height: 1.5em;
  border-bottom: 0;
}

.fc .fc-timegrid-slot:empty:before {
  content: '\\00a0';
  /* make sure there's at least an empty space to create height for height syncing */
}

.fc .fc-timegrid-slot-minor {
  border-top-style: dotted;
}

.fc .fc-timegrid-slot-label-cushion {
  display: inline-block;
  white-space: nowrap;
}

.fc .fc-timegrid-slot-label {
  vertical-align: middle;
  /* vertical align the slots */
}

.fc {
  /* slots AND axis cells (top-left corner of view including the "all-day" text) */
}

.fc .fc-timegrid-axis-cushion,
.fc .fc-timegrid-slot-label-cushion {
  padding: 0 4px;
}

.fc {
  /* axis cells (top-left corner of view including the "all-day" text) */
  /* vertical align is more complicated, uses flexbox */
}

.fc .fc-timegrid-axis-frame-liquid {
  height: 100%;
  /* will need liquid-hack in FF */
}

.fc .fc-timegrid-axis-frame {
  overflow: hidden;
  display: flex;
  align-items: center;
  /* vertical align */
  justify-content: flex-end;
  /* horizontal align. matches text-align below */
}

.fc .fc-timegrid-axis-cushion {
  max-width: 60px;
  /* limits the width of the "all-day" text */
  flex-shrink: 0;
  /* allows text to expand how it normally would, regardless of constrained width */
}

.fc-direction-ltr .fc-timegrid-slot-label-frame {
  text-align: right;
}

.fc-direction-rtl .fc-timegrid-slot-label-frame {
  text-align: left;
}

.fc-liquid-hack .fc-timegrid-axis-frame-liquid {
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.fc .fc-timegrid-col.fc-day-today {
  background-color: rgba(255, 220, 40, 0.15);
  background-color: var(--fc-today-bg-color, rgba(255, 220, 40, 0.15));
}

.fc .fc-timegrid-col-frame {
  min-height: 100%;
  /* liquid-hack is below */
  position: relative;
}

.fc-liquid-hack .fc-timegrid-col-frame {
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.fc-media-screen .fc-timegrid-cols {
  position: absolute;
  /* no z-index. children will decide and go above slots */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.fc-media-screen .fc-timegrid-cols>table {
  height: 100%;
}

.fc-media-screen .fc-timegrid-col-bg,
.fc-media-screen .fc-timegrid-col-events,
.fc-media-screen .fc-timegrid-now-indicator-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.fc-media-screen .fc-timegrid-event-harness {
  position: absolute;
  /* top/left/right/bottom will all be set by JS */
}

.fc {
  /* bg */
}

.fc .fc-timegrid-col-bg {
  z-index: 2;
  /* TODO: kill */
}

.fc .fc-timegrid-col-bg .fc-non-business {
  z-index: 1;
}

.fc .fc-timegrid-col-bg .fc-bg-event {
  z-index: 2;
}

.fc .fc-timegrid-col-bg .fc-highlight {
  z-index: 3;
}

.fc .fc-timegrid-bg-harness {
  position: absolute;
  /* top/bottom will be set by JS */
  left: 0;
  right: 0;
}

.fc {
  /* fg events */
  /* (the mirror segs are put into a separate container with same classname, */
  /* and they must be after the normal seg container to appear at a higher z-index) */
}

.fc .fc-timegrid-col-events {
  z-index: 3;
  /* child event segs have z-indexes that are scoped within this div */
}

.fc {
  /* now indicator */
}

.fc .fc-timegrid-now-indicator-container {
  bottom: 0;
  overflow: hidden;
  /* don't let overflow of lines/arrows cause unnecessary scrolling */
  /* z-index is set on the individual elements */
}

.fc-direction-ltr .fc-timegrid-col-events {
  margin: 0 2.5% 0 2px;
}

.fc-direction-rtl .fc-timegrid-col-events {
  margin: 0 2px 0 2.5%;
}

.fc-timegrid-event-harness-inset .fc-timegrid-event,
.fc-timegrid-event.fc-event-mirror {
  box-shadow: 0px 0px 0px 1px #fff;
  box-shadow: 0px 0px 0px 1px var(--fc-page-bg-color, #fff);
}

.fc-timegrid-event {
  /* events need to be root */
  font-size: .85em;
  font-size: var(--fc-small-font-size, 0.85em);
  border-radius: 3px;
}

.fc-timegrid-event .fc-event-main {
  padding: 1px 1px 0;
}

.fc-timegrid-event .fc-event-time {
  white-space: nowrap;
  font-size: .85em;
  font-size: var(--fc-small-font-size, 0.85em);
  margin-bottom: 1px;
}

.fc-timegrid-event-condensed .fc-event-main-frame {
  flex-direction: row;
  overflow: hidden;
}

.fc-timegrid-event-condensed .fc-event-time:after {
  content: '\\00a0-\\00a0';
  /* dash surrounded by non-breaking spaces */
}

.fc-timegrid-event-condensed .fc-event-title {
  font-size: .85em;
  font-size: var(--fc-small-font-size, 0.85em);
}

.fc-media-screen .fc-timegrid-event {
  position: absolute;
  /* absolute WITHIN the harness */
  top: 0;
  bottom: 1px;
  /* stay away from bottom slot line */
  left: 0;
  right: 0;
}

.fc {
  /* line */
}

.fc .fc-timegrid-now-indicator-line {
  position: absolute;
  z-index: 4;
  left: 0;
  right: 0;
  border-style: solid;
  border-color: red;
  border-color: var(--fc-now-indicator-color, red);
  border-width: 1px 0 0;
}

.fc {
  /* arrow */
}

.fc .fc-timegrid-now-indicator-arrow {
  position: absolute;
  z-index: 4;
  margin-top: -5px;
  /* vertically center on top coordinate */
  border-style: solid;
  border-color: red;
  border-color: var(--fc-now-indicator-color, red);
}

.fc-direction-ltr .fc-timegrid-now-indicator-arrow {
  left: 0;
  /* triangle pointing right. TODO: mixin */
  border-width: 5px 0 5px 6px;
  border-top-color: transparent;
  border-bottom-color: transparent;
}

.fc-direction-rtl .fc-timegrid-now-indicator-arrow {
  right: 0;
  /* triangle pointing left. TODO: mixin */
  border-width: 5px 6px 5px 0;
  border-top-color: transparent;
  border-bottom-color: transparent;
}

:root {
  --fc-list-event-dot-width: 10px;
  --fc-list-event-hover-bg-color: #f5f5f5;
}

.fc-theme-standard .fc-list {
  border: 1px solid #ddd;
  border: 1px solid var(--fc-border-color, #ddd);
}

.fc {
  /* message when no events */
}

.fc .fc-list-empty {
  background-color: rgba(208, 208, 208, 0.3);
  background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* vertically aligns fc-list-empty-inner */
}

.fc .fc-list-empty-cushion {
  margin: 5em 0;
}

.fc {
  /* table within the scroller */
  /* ---------------------------------------------------------------------------------------------------- */
}

.fc .fc-list-table {
  width: 100%;
  border-style: hidden;
  /* kill outer border on theme */
}

.fc .fc-list-table tr>* {
  border-left: 0;
  border-right: 0;
}

.fc .fc-list-sticky .fc-list-day>* {
  /* the cells */
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background: #fff;
  background: var(--fc-page-bg-color, #fff);
  /* for when headers are styled to be transparent and sticky */
}

.fc .fc-list-table th {
  padding: 0;
  /* uses an inner-wrapper instead... */
}

.fc .fc-list-table td,
.fc .fc-list-day-cushion {
  padding: 8px 14px;
}

.fc {
  /* date heading rows */
  /* ---------------------------------------------------------------------------------------------------- */
}

.fc .fc-list-day-cushion:after {
  content: "";
  clear: both;
  display: table;
  /* clear floating */
}

.fc-theme-standard .fc-list-day-cushion {
  background-color: rgba(208, 208, 208, 0.3);
  background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));
}

.fc-direction-ltr .fc-list-day-text,
.fc-direction-rtl .fc-list-day-side-text {
  float: left;
}

.fc-direction-ltr .fc-list-day-side-text,
.fc-direction-rtl .fc-list-day-text {
  float: right;
}

/* make the dot closer to the event title */
.fc-direction-ltr .fc-list-table .fc-list-event-graphic {
  padding-right: 0;
}

.fc-direction-rtl .fc-list-table .fc-list-event-graphic {
  padding-left: 0;
}

.fc .fc-list-event.fc-event-forced-url {
  cursor: pointer;
  /* whole row will seem clickable */
}

.fc .fc-list-event:hover td {
  background-color: #f5f5f5;
  background-color: var(--fc-list-event-hover-bg-color, #f5f5f5);
}

.fc {
  /* shrink certain cols */
}

.fc .fc-list-event-graphic,
.fc .fc-list-event-time {
  white-space: nowrap;
  width: 1px;
}

.fc .fc-list-event-dot {
  display: inline-block;
  box-sizing: content-box;
  width: 0;
  height: 0;
  border: 5px solid #3788d8;
  border: calc(var(--fc-list-event-dot-width, 10px) / 2) solid var(--fc-event-border-color, #3788d8);
  border-radius: 5px;
  border-radius: calc(var(--fc-list-event-dot-width, 10px) / 2);
}

.fc {
  /* reset <a> styling */
}

.fc .fc-list-event-title a {
  color: inherit;
  text-decoration: none;
}

.fc {
  /* underline link when hovering over any part of row */
}

.fc .fc-list-event.fc-event-forced-url:hover a {
  text-decoration: underline;
}

`, "",{"version":3,"sources":["webpack://./style/style.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,sCAAsC;;AAEtC,0CAA0C;AAC1C,iCAAiC;AACjC,sBAAsB;AACtB,IAAI;;AAEJ,mDAAmD;AACnD,iCAAiC;AACjC,IAAI;;AAEJ,+BAA+B;AAC/B,iCAAiC;AACjC,6BAA6B;AAC7B,IAAI;;AAEJ,wBAAwB;AACxB,8BAA8B;AAC9B,uCAAuC;AACvC,sCAAsC;AACtC,8BAA8B;AAC9B,uEAAuE;AACvE,oBAAoB;AACpB,+BAA+B;AAC/B,IAAI;;AAEJ;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,mGAAmG;AACrG;;AAEA;EACE,oGAAoG;AACtG;;AAEA;EACE,mGAAmG;AACrG;;AAEA;EACE,mGAAmG;AACrG;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,oGAAoG;AACtG;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,oGAAoG;AACtG;;AAEA;EACE,mGAAmG;AACrG;;AAEA;EACE,oGAAoG;AACtG;;AAEA;EACE,mGAAmG;AACrG;;AAEA;EACE,mGAAmG;AACrG;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,oGAAoG;AACtG;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;;CAIC;AACD,+BAA+B;AAC/B,+BAA+B;AAC/B;;EAEE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA,0FAA0F;AAC1F,sDAAsD;AACtD,+BAA+B;AAC/B;;EAEE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAA4mG;EAC5mG,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,+EAA+E;EAC/E,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;CAKC;AACD;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,yBAAyB;EACzB,oDAAoD;EACpD,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,yBAAyB;EACzB,0DAA0D;EAC1D,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wCAAwC;EACxC,yBAAyB;EACzB,oDAAoD;EACpD,qBAAqB;EACrB,oDAAoD;EACpD,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,WAAW;EACX,wCAAwC;EACxC,yBAAyB;EACzB,2DAA2D;EAC3D,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gGAAgG;AAClG;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0EAA0E;EAC1E,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uFAAuF;EACvF,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;EAC/B,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wEAAwE;AAC1E;;AAEA;EACE,WAAW;EACX,+FAA+F;EAC/F,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,wBAAwB;EACxB,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,MAAM;EACN,mDAAmD;EACnD,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,wDAAwD;AAC1D;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,uDAAuD;EACvD,gBAAgB;AAClB;;AAEA;;;EAGE,qFAAqF;EACrF,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;IACI,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,+DAA+D;AACjE;;AAEA;;EAEE,oCAAoC;EACpC,gEAAgE;AAClE;;AAEA,gBAAgB;AAChB,yGAAyG;AACzG;;EAEE,qBAAqB;AACvB;;AAEA,WAAW;AACX;;EAEE,eAAe;AACjB;;AAEA,uBAAuB;AACvB,yGAAyG;AACzG;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,aAAa;AACb,yGAAyG;AACzG;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,UAAU;EACV,wCAAwC;AAC1C;;AAEA,aAAa;AACb,yGAAyG;AACzG,iEAAiE;AACjE;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qEAAqE;EACrE,iBAAiB;EACjB,2DAA2D;EAC3D,UAAU;EACV,mDAAmD;EACnD,WAAW;EACX,oDAAoD;EACpD,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA,6BAA6B;AAC7B,yGAAyG;AACzG;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,uEAAuE;EACvE,kBAAkB;EAClB,UAAU;EACV,uDAAuD;EACvD,0EAA0E;EAC1E,0CAA0C;EAC1C,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;CAEC;AACD;EACE,4BAA4B;EAC5B,cAAc;EACd,yBAAyB;EACzB,uDAAuD;EACvD,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;EACzC,mBAAmB;EACnB,mCAAmC;EACnC,OAAO;EACP,eAAe;EACf,QAAQ;EACR,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,aAAa;AACf;;AAEA,wEAAwE;AACxE;;EAEE,yBAAyB;EACzB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,MAAM;EACN,SAAS;EACT,UAAU;EACV,6CAA6C;AAC/C;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,uDAAuD;AACzD;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,wDAAwD;AAC1D;;AAEA,uBAAuB;AACvB;EACE,QAAQ;EACR,gBAAgB;EAChB,mEAAmE;AACrE;;AAEA;;EAEE,UAAU;EACV,6DAA6D;AAC/D;;AAEA;;EAEE,WAAW;EACX,8DAA8D;AAChE;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;EAC9C,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,gEAAgE;AAClE;;AAEA,+CAA+C;AAC/C;;;EAGE,iCAAiC;AACnC;;AAEA;;;EAGE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,UAAU;EACV,wDAAwD;AAC1D;;AAEA;EACE,0CAA0C;EAC1C,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4FAA4F;AAC9F;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mFAAmF;AACrF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,eAAe;EACf,gGAAgG;AAClG;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,oDAAoD;EACpD,OAAO;EACP,IAAI;EACJ,QAAQ;EACR,IAAI;AACN;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,sEAAsE;EACtE,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,qFAAqF;EACrF,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA,mDAAmD;AACnD;EACE,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,iDAAiD;EACjD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,oGAAoG;EACpG,kBAAkB;EAClB,+DAA+D;AACjE;;AAEA,2CAA2C;AAC3C;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;CAEC;AACD;EACE,4BAA4B;EAC5B,cAAc;EACd,yBAAyB;EACzB,uDAAuD;EACvD,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,cAAc;EACd,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,8BAA8B;EAC9B,MAAM;EACN,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,8CAA8C;EAC9C,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,yDAAyD;AAC3D;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,oEAAoE;AACtE;;AAEA;EACE,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE,YAAY;EACZ,+DAA+D;AACjE;;AAEA;EACE,iDAAiD;EACjD,UAAU;EACV,gGAAgG;AAClG;;AAEA;EACE,gBAAgB;EAChB,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,0CAA0C;EAC1C,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kFAAkF;AACpF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,gFAAgF;AAClF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,sEAAsE;EACtE,qDAAqD;AACvD;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,0CAA0C;EAC1C,oEAAoE;AACtE;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;EACxD,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,4EAA4E;EAC5E,mFAAmF;AACrF;;AAEA;EACE,UAAU;EACV,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,mEAAmE;EACnE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,MAAM;EACN,WAAW;EACX,oCAAoC;EACpC,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,gDAAgD;EAChD,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,OAAO;EACP,yCAAyC;EACzC,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,wCAAwC;EACxC,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,sEAAsE;EACtE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,yGAAyG;AAC3G;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,yCAAyC;EACzC,6DAA6D;AAC/D;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,yGAAyG;AAC3G;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,sEAAsE;AACxE;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,8DAA8D;AAChE;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,kGAAkG;EAClG,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["@charset \"UTF-8\";\n\n/* the main calendar container theme */\n\n/*.fc { !* the main calendar container *!*/\n/*    background-color: #1f2023;*/\n/*    color: #ecf0f1;*/\n/*}*/\n\n/*.fc-daygrid-day { !* the individual day cells *!*/\n/*    background-color: #1d2731;*/\n/*}*/\n\n/*.fc-event { !* the events *!*/\n/*    background-color: #3498db;*/\n/*    border-color: #3498db;*/\n/*}*/\n\n/*.ql-toolbar.ql-snow {*/\n/*    border: 1px solid #fff;*/\n/*    border-top-right-radius: 0.5rem;*/\n/*    border-top-left-radius: 0.5rem;*/\n/*    box-sizing: border-box;*/\n/*    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;*/\n/*    padding: 8px;*/\n/*    background-color: white;*/\n/*}*/\n\n.fc {\n    height: 90vh !important;\n    width: 100% !important;\n}\n\n.bg-primary {\n  background-color: #5e72e4 !important;\n}\n\n.bg-secondary {\n  background-color: #8392ab !important;\n}\n\n.bg-success {\n  background-color: #2dce89 !important;\n}\n\n.bg-info {\n  background-color: #11cdef !important;\n}\n\n.bg-warning {\n  background-color: #fb6340 !important;\n}\n\n.bg-danger {\n  background-color: #f5365c !important;\n}\n\n.bg-light {\n  background-color: #e9ecef !important;\n}\n\n.bg-dark {\n  background-color: #344767 !important;\n}\n\n.bg-white {\n  background-color: #fff !important;\n}\n\n.bg-body {\n  background-color: #fff !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.bg-gray-100 {\n  background-color: #f8f9fa !important;\n}\n\n.bg-gray-200 {\n  background-color: #e9ecef !important;\n}\n\n.bg-gray-300 {\n  background-color: #dee2e6 !important;\n}\n\n.bg-gray-400 {\n  background-color: #ced4da !important;\n}\n\n.bg-gray-500 {\n  background-color: #adb5bd !important;\n}\n\n.bg-gray-600 {\n  background-color: #6c757d !important;\n}\n\n.bg-gray-700 {\n  background-color: #495057 !important;\n}\n\n.bg-gray-800 {\n  background-color: #343a40 !important;\n}\n\n.bg-gray-900 {\n  background-color: #212529 !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.bg-gradient-primary {\n  background-image: linear-gradient(310deg, #5e72e4 0%, #825ee4 100%);\n}\n\n.bg-gradient-secondary {\n  background-image: linear-gradient(310deg, #627594 0%, #a8b8d8 100%);\n}\n\n.bg-gradient-success {\n  background-image: linear-gradient(310deg, #2dce89 0%, #2dcecc 100%);\n}\n\n.bg-gradient-info {\n  background-image: linear-gradient(310deg, #1171ef 0%, #11cdef 100%);\n}\n\n.bg-gradient-warning {\n  background-image: linear-gradient(310deg, #fb6340 0%, #fbb140 100%);\n}\n\n.bg-gradient-danger {\n  background-image: linear-gradient(310deg, #f5365c 0%, #f56036 100%);\n}\n\n.bg-gradient-light {\n  background-image: linear-gradient(310deg, #CED4DA 0%, #EBEFF4 100%);\n}\n\n.bg-gradient-dark {\n  background-image: linear-gradient(310deg, #212229 0%, #212529 100%);\n}\n\n.bg-gradient-faded-primary {\n  background-image: radial-gradient(370px circle at 80% 50%, rgba(94, 114, 228, 0.6) 0, #324cdd 100%);\n}\n\n.bg-gradient-faded-secondary {\n  background-image: radial-gradient(370px circle at 80% 50%, rgba(131, 146, 171, 0.6) 0, #657796 100%);\n}\n\n.bg-gradient-faded-success {\n  background-image: radial-gradient(370px circle at 80% 50%, rgba(45, 206, 137, 0.6) 0, #24a46d 100%);\n}\n\n.bg-gradient-faded-info {\n  background-image: radial-gradient(370px circle at 80% 50%, rgba(17, 205, 239, 0.6) 0, #0da5c0 100%);\n}\n\n.bg-gradient-faded-warning {\n  background-image: radial-gradient(370px circle at 80% 50%, rgba(251, 99, 64, 0.6) 0, #fa3a0e 100%);\n}\n\n.bg-gradient-faded-danger {\n  background-image: radial-gradient(370px circle at 80% 50%, rgba(245, 54, 92, 0.6) 0, #ec0c38 100%);\n}\n\n.bg-gradient-faded-light {\n  background-image: radial-gradient(370px circle at 80% 50%, rgba(233, 236, 239, 0.6) 0, #cbd3da 100%);\n}\n\n.bg-gradient-faded-dark {\n  background-image: radial-gradient(370px circle at 80% 50%, rgba(52, 71, 103, 0.6) 0, #233045 100%);\n}\n\n.bg-gradient-faded-white {\n  background-image: radial-gradient(370px circle at 80% 50%, rgba(255, 255, 255, 0.6) 0, #e6e6e6 100%);\n}\n\n.bg-gradient-faded-primary-vertical {\n  background-image: radial-gradient(200px circle at 50% 70%, rgba(94, 114, 228, 0.3) 0, #5e72e4 100%);\n}\n\n.bg-gradient-faded-secondary-vertical {\n  background-image: radial-gradient(200px circle at 50% 70%, rgba(131, 146, 171, 0.3) 0, #8392ab 100%);\n}\n\n.bg-gradient-faded-success-vertical {\n  background-image: radial-gradient(200px circle at 50% 70%, rgba(45, 206, 137, 0.3) 0, #2dce89 100%);\n}\n\n.bg-gradient-faded-info-vertical {\n  background-image: radial-gradient(200px circle at 50% 70%, rgba(17, 205, 239, 0.3) 0, #11cdef 100%);\n}\n\n.bg-gradient-faded-warning-vertical {\n  background-image: radial-gradient(200px circle at 50% 70%, rgba(251, 99, 64, 0.3) 0, #fb6340 100%);\n}\n\n.bg-gradient-faded-danger-vertical {\n  background-image: radial-gradient(200px circle at 50% 70%, rgba(245, 54, 92, 0.3) 0, #f5365c 100%);\n}\n\n.bg-gradient-faded-light-vertical {\n  background-image: radial-gradient(200px circle at 50% 70%, rgba(233, 236, 239, 0.3) 0, #e9ecef 100%);\n}\n\n.bg-gradient-faded-dark-vertical {\n  background-image: radial-gradient(200px circle at 50% 70%, rgba(52, 71, 103, 0.3) 0, #344767 100%);\n}\n\n.bg-gradient-faded-white-vertical {\n  background-image: radial-gradient(200px circle at 50% 70%, rgba(255, 255, 255, 0.3) 0, #fff 100%);\n}\n\n.bg-primary-soft {\n  background: rgba(94, 114, 228, 0.03);\n}\n\n.bg-info-soft {\n  background: rgba(17, 113, 239, 0.03);\n}\n\n.bg-success-soft {\n  background: rgba(45, 206, 137, 0.03);\n}\n\n.bg-warning-soft {\n  background: rgba(251, 99, 64, 0.03);\n}\n\n.bg-danger-soft {\n  background: rgba(245, 54, 92, 0.03);\n}\n\n/*!\nFullCalendar v5.6.0\nDocs & License: https://fullcalendar.io/\n(c) 2020 Adam Shaw\n*/\n/* classes attached to <body> */\n/* classes attached to <body> */\n.fc-not-allowed,\n.fc-not-allowed .fc-event {\n  /* override events' custom cursors */\n  cursor: not-allowed;\n}\n\n.fc-unselectable {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.fc {\n  /* layout of immediate children */\n  display: flex;\n  flex-direction: column;\n  font-size: 1em;\n}\n\n.fc,\n.fc *,\n.fc *:before,\n.fc *:after {\n  box-sizing: border-box;\n}\n\n.fc table {\n  border-collapse: collapse;\n  border-spacing: 0;\n  font-size: 1em;\n  /* normalize cross-browser */\n}\n\n.fc th {\n  text-align: center;\n}\n\n.fc th,\n.fc td {\n  vertical-align: top;\n  padding: 0;\n}\n\n.fc a[data-navlink] {\n  cursor: pointer;\n}\n\n.fc a[data-navlink]:hover {\n  text-decoration: underline;\n}\n\n.fc-direction-ltr {\n  direction: ltr;\n  text-align: left;\n}\n\n.fc-direction-rtl {\n  direction: rtl;\n  text-align: right;\n}\n\n.fc-theme-standard td,\n.fc-theme-standard th {\n  border: 1px solid #ddd;\n  border: 1px solid var(--fc-border-color, #ddd);\n}\n\n/* for FF, which doesn't expand a 100% div within a table cell. use absolute positioning */\n/* inner-wrappers are responsible for being absolute */\n/* TODO: best place for this? */\n.fc-liquid-hack td,\n.fc-liquid-hack th {\n  position: relative;\n}\n\n@font-face {\n  font-family: 'fcicons';\n  src: url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.fc-icon {\n  /* added for fc */\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  text-align: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'fcicons' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.fc-icon-chevron-left:before {\n  content: \"\\e900\";\n}\n\n.fc-icon-chevron-right:before {\n  content: \"\\e901\";\n}\n\n.fc-icon-chevrons-left:before {\n  content: \"\\e902\";\n}\n\n.fc-icon-chevrons-right:before {\n  content: \"\\e903\";\n}\n\n.fc-icon-minus-square:before {\n  content: \"\\e904\";\n}\n\n.fc-icon-plus-square:before {\n  content: \"\\e905\";\n}\n\n.fc-icon-x:before {\n  content: \"\\e906\";\n}\n\n/*\nLots taken from Flatly (MIT): https://bootswatch.com/4/flatly/bootstrap.css\n\nThese styles only apply when the standard-theme is activated.\nWhen it's NOT activated, the fc-button classes won't even be in the DOM.\n*/\n.fc {\n  /* reset */\n}\n\n.fc .fc-button {\n  border-radius: 0;\n  overflow: visible;\n  text-transform: none;\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\n.fc .fc-button:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\n.fc .fc-button {\n  -webkit-appearance: button;\n}\n\n.fc .fc-button:not(:disabled) {\n  cursor: pointer;\n}\n\n.fc .fc-button::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n.fc {\n  /* theme */\n}\n\n.fc .fc-button {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.4em 0.65em;\n  font-size: 1em;\n  line-height: 1.5;\n  border-radius: 0.25em;\n}\n\n.fc .fc-button:hover {\n  text-decoration: none;\n}\n\n.fc .fc-button:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(44, 62, 80, 0.25);\n}\n\n.fc .fc-button:disabled {\n  opacity: 0.65;\n}\n\n.fc {\n  /* \"primary\" coloring */\n}\n\n.fc .fc-button-primary {\n  color: #fff;\n  color: var(--fc-button-text-color, #fff);\n  background-color: #2C3E50;\n  background-color: var(--fc-button-bg-color, #2C3E50);\n  border-color: #2C3E50;\n  border-color: var(--fc-button-border-color, #2C3E50);\n}\n\n.fc .fc-button-primary:hover {\n  color: #fff;\n  color: var(--fc-button-text-color, #fff);\n  background-color: #1e2b37;\n  background-color: var(--fc-button-hover-bg-color, #1e2b37);\n  border-color: #1a252f;\n  border-color: var(--fc-button-hover-border-color, #1a252f);\n}\n\n.fc .fc-button-primary:disabled {\n  /* not DRY */\n  color: #fff;\n  color: var(--fc-button-text-color, #fff);\n  background-color: #2C3E50;\n  background-color: var(--fc-button-bg-color, #2C3E50);\n  border-color: #2C3E50;\n  border-color: var(--fc-button-border-color, #2C3E50);\n  /* overrides :hover */\n}\n\n.fc .fc-button-primary:focus {\n  box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);\n}\n\n.fc .fc-button-primary:not(:disabled):active,\n.fc .fc-button-primary:not(:disabled).fc-button-active {\n  color: #fff;\n  color: var(--fc-button-text-color, #fff);\n  background-color: #1a252f;\n  background-color: var(--fc-button-active-bg-color, #1a252f);\n  border-color: #151e27;\n  border-color: var(--fc-button-active-border-color, #151e27);\n}\n\n.fc .fc-button-primary:not(:disabled):active:focus,\n.fc .fc-button-primary:not(:disabled).fc-button-active:focus {\n  box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);\n}\n\n.fc {\n  /* icons within buttons */\n}\n\n.fc .fc-button .fc-icon {\n  vertical-align: middle;\n  font-size: 1.5em;\n  /* bump up the size (but don't make it bigger than line-height of button, which is 1.5em also) */\n}\n\n.fc .fc-button-group {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.fc .fc-button-group>.fc-button {\n  position: relative;\n  flex: 1 1 auto;\n}\n\n.fc .fc-button-group>.fc-button:hover {\n  z-index: 1;\n}\n\n.fc .fc-button-group>.fc-button:focus,\n.fc .fc-button-group>.fc-button:active,\n.fc .fc-button-group>.fc-button.fc-button-active {\n  z-index: 1;\n}\n\n.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child) {\n  margin-left: -1px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child) {\n  margin-right: -1px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.fc .fc-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.fc .fc-toolbar.fc-header-toolbar {\n  margin-bottom: 1.5em;\n}\n\n.fc .fc-toolbar.fc-footer-toolbar {\n  margin-top: 1.5em;\n}\n\n.fc .fc-toolbar-title {\n  font-size: 1.75em;\n  margin: 0;\n}\n\n.fc-direction-ltr .fc-toolbar>*> :not(:first-child) {\n  margin-left: .75em;\n  /* space between */\n}\n\n.fc-direction-rtl .fc-toolbar>*> :not(:first-child) {\n  margin-right: .75em;\n  /* space between */\n}\n\n.fc-direction-rtl .fc-toolbar-ltr {\n  /* when the toolbar-chunk positioning system is explicitly left-to-right */\n  flex-direction: row-reverse;\n}\n\n.fc .fc-scroller {\n  -webkit-overflow-scrolling: touch;\n  position: relative;\n  /* for abs-positioned elements within */\n}\n\n.fc .fc-scroller-liquid {\n  height: 100%;\n}\n\n.fc .fc-scroller-liquid-absolute {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n}\n\n.fc .fc-scroller-harness {\n  position: relative;\n  overflow: hidden;\n  direction: ltr;\n  /* hack for chrome computing the scroller's right/left wrong for rtl. undone below... */\n  /* TODO: demonstrate in codepen */\n}\n\n.fc .fc-scroller-harness-liquid {\n  height: 100%;\n}\n\n.fc-direction-rtl .fc-scroller-harness>.fc-scroller {\n  /* undo above hack */\n  direction: rtl;\n}\n\n.fc-theme-standard .fc-scrollgrid {\n  border: 1px solid #ddd;\n  border: 1px solid var(--fc-border-color, #ddd);\n  /* bootstrap does this. match */\n}\n\n.fc .fc-scrollgrid,\n.fc .fc-scrollgrid table {\n  /* all tables (self included) */\n  width: 100%;\n  /* because tables don't normally do this */\n  table-layout: fixed;\n}\n\n.fc .fc-scrollgrid table {\n  /* inner tables */\n  border-top-style: hidden;\n  border-left-style: hidden;\n  border-right-style: hidden;\n}\n\n.fc .fc-scrollgrid {\n  border-collapse: separate;\n  border-right-width: 0;\n  border-bottom-width: 0;\n}\n\n.fc .fc-scrollgrid-liquid {\n  height: 100%;\n}\n\n.fc .fc-scrollgrid-section {\n  /* a <tr> */\n  height: 1px;\n}\n\n.fc .fc-scrollgrid-section>td {\n  height: 1px;\n  /* needs a height so inner div within grow. better than 0, for firefox */\n}\n\n.fc .fc-scrollgrid-section table {\n  height: 1px;\n  /* for most browsers, if a height isn't set on the table, can't do liquid-height within cells */\n  /* serves as a min-height. harmless */\n}\n\n.fc .fc-scrollgrid-section-liquid {\n  height: auto;\n}\n\n.fc .fc-scrollgrid-section-liquid>td {\n  height: 100%;\n  /* better than `auto`, for firefox */\n}\n\n.fc .fc-scrollgrid-section>* {\n  border-top-width: 0;\n  border-left-width: 0;\n}\n\n.fc .fc-scrollgrid-section-header>*,\n.fc .fc-scrollgrid-section-footer>* {\n  border-bottom-width: 0;\n}\n\n.fc .fc-scrollgrid-section-body table,\n.fc .fc-scrollgrid-section-footer table {\n  border-bottom-style: hidden;\n  /* head keeps its bottom border tho */\n}\n\n.fc {\n  /* stickiness */\n}\n\n.fc .fc-scrollgrid-section-sticky>* {\n  background: #fff;\n  background: var(--fc-page-bg-color, #fff);\n  position: -webkit-sticky;\n  position: sticky;\n  z-index: 2;\n  /* TODO: var */\n  /* TODO: box-shadow when sticking */\n}\n\n.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>* {\n  top: 0;\n  /* because border-sharing causes a gap at the top */\n  /* TODO: give safari -1. has bug */\n}\n\n.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>* {\n  bottom: 0;\n  /* known bug: bottom-stickiness doesn't work in safari */\n}\n\n.fc .fc-scrollgrid-sticky-shim {\n  /* for horizontal scrollbar */\n  height: 1px;\n  /* needs height to create scrollbars */\n  margin-bottom: -1px;\n}\n\n.fc-sticky {\n  /* no .fc wrap because used as child of body */\n  position: -webkit-sticky;\n  position: sticky;\n}\n\n.fc .fc-view-harness {\n  flex-grow: 1;\n  /* because this harness is WITHIN the .fc's flexbox */\n  position: relative;\n}\n\n.fc {\n  /* when the harness controls the height, make the view liquid */\n}\n\n.fc .fc-view-harness-active>.fc-view {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.fc .fc-col-header-cell-cushion {\n  display: inline-block;\n  /* x-browser for when sticky (when multi-tier header) */\n  padding: 2px 4px;\n}\n\n.fc .fc-bg-event,\n.fc .fc-non-business,\n.fc .fc-highlight {\n  /* will always have a harness with position:relative/absolute, so absolutely expand */\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.fc .fc-non-business {\n    background: rgba(215, 215, 215, 0.3);\n    background: hsl(0deg 0% 0% / 81%);\n}\n\n.fc .fc-bg-event {\n  background: #8fdf82;\n  background: var(--fc-bg-event-color, #8fdf82);\n  opacity: 0.3;\n  opacity: var(--fc-bg-event-opacity, 0.3);\n}\n\n.fc .fc-bg-event .fc-event-title {\n  margin: .5em;\n  font-size: .85em;\n  font-size: var(--fc-small-font-size, 0.85em);\n  font-style: italic;\n}\n\n.fc .fc-highlight {\n  background: rgba(188, 232, 241, 0.3);\n  background: var(--fc-highlight-color, rgba(188, 232, 241, 0.3));\n}\n\n.fc .fc-cell-shaded,\n.fc .fc-day-disabled {\n  background: rgba(208, 208, 208, 0.3);\n  background: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));\n}\n\n/* link resets */\n/* ---------------------------------------------------------------------------------------------------- */\na.fc-event,\na.fc-event:hover {\n  text-decoration: none;\n}\n\n/* cursor */\n.fc-event[href],\n.fc-event.fc-event-draggable {\n  cursor: pointer;\n}\n\n/* event text content */\n/* ---------------------------------------------------------------------------------------------------- */\n.fc-event .fc-event-main {\n  position: relative;\n  z-index: 2;\n}\n\n/* dragging */\n/* ---------------------------------------------------------------------------------------------------- */\n.fc-event-dragging:not(.fc-event-selected) {\n  /* MOUSE */\n  opacity: 0.75;\n}\n\n.fc-event-dragging.fc-event-selected {\n  /* TOUCH */\n  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.3);\n}\n\n/* resizing */\n/* ---------------------------------------------------------------------------------------------------- */\n/* (subclasses should hone positioning for touch and non-touch) */\n.fc-event .fc-event-resizer {\n  display: none;\n  position: absolute;\n  z-index: 4;\n}\n\n.fc-event:hover,\n.fc-event-selected {\n  /* TOUCH */\n}\n\n.fc-event:hover .fc-event-resizer,\n.fc-event-selected .fc-event-resizer {\n  display: block;\n}\n\n.fc-event-selected .fc-event-resizer {\n  border-radius: 4px;\n  border-radius: calc(var(--fc-event-resizer-dot-total-width, 8px) / 2);\n  border-width: 1px;\n  border-width: var(--fc-event-resizer-dot-border-width, 1px);\n  width: 8px;\n  width: var(--fc-event-resizer-dot-total-width, 8px);\n  height: 8px;\n  height: var(--fc-event-resizer-dot-total-width, 8px);\n  border-style: solid;\n  border-color: inherit;\n  background: #fff;\n  background: var(--fc-page-bg-color, #fff);\n}\n\n.fc-event-selected .fc-event-resizer:before {\n  content: '';\n  position: absolute;\n  top: -20px;\n  left: -20px;\n  right: -20px;\n  bottom: -20px;\n}\n\n/* selecting (always TOUCH) */\n/* ---------------------------------------------------------------------------------------------------- */\n.fc-event-selected {\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.fc-event-selected:before {\n  content: \"\";\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.fc-event-selected {\n  /* dimmer effect */\n}\n\n.fc-event-selected:after {\n  content: \"\";\n  background: rgba(0, 0, 0, 0.25);\n  background: var(--fc-event-selected-overlay-color, rgba(0, 0, 0, 0.25));\n  position: absolute;\n  z-index: 1;\n  /* assume there's a border on all sides. overcome it. */\n  /* sometimes there's NOT a border, in which case the dimmer will go over */\n  /* an adjacent border, which looks fine. */\n  top: -1px;\n  left: -1px;\n  right: -1px;\n  bottom: -1px;\n}\n\n/*\nA HORIZONTAL event\n*/\n.fc-h-event {\n  /* allowed to be top-level */\n  display: block;\n  border: 1px solid #3788d8;\n  border: 1px solid var(--fc-event-border-color, #3788d8);\n  background-color: #3788d8;\n  background-color: var(--fc-event-bg-color, #3788d8);\n}\n\n.fc-h-event .fc-event-main {\n  color: #fff;\n  color: var(--fc-event-text-color, #fff);\n}\n\n.fc-h-event .fc-event-main-frame {\n  display: flex;\n  /* for make fc-event-title-container expand */\n}\n\n.fc-h-event .fc-event-time {\n  max-width: 100%;\n  /* clip overflow on this element */\n  overflow: hidden;\n}\n\n.fc-h-event .fc-event-title-container {\n  /* serves as a container for the sticky cushion */\n  flex-grow: 1;\n  flex-shrink: 1;\n  min-width: 0;\n  /* important for allowing to shrink all the way */\n}\n\n.fc-h-event .fc-event-title {\n  display: inline-block;\n  /* need this to be sticky cross-browser */\n  vertical-align: top;\n  /* for not messing up line-height */\n  left: 0;\n  /* for sticky */\n  right: 0;\n  /* for sticky */\n  max-width: 100%;\n  /* clip overflow on this element */\n  overflow: hidden;\n}\n\n.fc-h-event.fc-event-selected:before {\n  /* expand hit area */\n  top: -10px;\n  bottom: -10px;\n}\n\n/* adjust border and border-radius (if there is any) for non-start/end */\n.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),\n.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-left-width: 0;\n}\n\n.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),\n.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right-width: 0;\n}\n\n/* resizers */\n.fc-h-event:not(.fc-event-selected) .fc-event-resizer {\n  top: 0;\n  bottom: 0;\n  width: 8px;\n  width: var(--fc-event-resizer-thickness, 8px);\n}\n\n.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,\n.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end {\n  cursor: w-resize;\n  left: -4px;\n  left: calc(var(--fc-event-resizer-thickness, 8px) / -2);\n}\n\n.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,\n.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start {\n  cursor: e-resize;\n  right: -4px;\n  right: calc(var(--fc-event-resizer-thickness, 8px) / -2);\n}\n\n/* resizers for TOUCH */\n.fc-h-event.fc-event-selected .fc-event-resizer {\n  top: 50%;\n  margin-top: -4px;\n  margin-top: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n}\n\n.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,\n.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end {\n  left: -4px;\n  left: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n}\n\n.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,\n.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start {\n  right: -4px;\n  right: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n}\n\n:root {\n  --fc-daygrid-event-dot-width: 8px;\n}\n\n.fc .fc-popover {\n  position: fixed;\n  top: 0;\n  /* for when not positioned yet */\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n.fc .fc-popover-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 3px 4px;\n}\n\n.fc .fc-popover-title {\n  margin: 0 2px;\n}\n\n.fc .fc-popover-close {\n  cursor: pointer;\n  opacity: 0.65;\n  font-size: 1.1em;\n}\n\n.fc-theme-standard .fc-popover {\n  border: 1px solid #ddd;\n  border: 1px solid var(--fc-border-color, #ddd);\n  background: #fff;\n  background: var(--fc-page-bg-color, #fff);\n}\n\n.fc-theme-standard .fc-popover-header {\n  background: rgba(208, 208, 208, 0.3);\n  background: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));\n}\n\n/* help things clear margins of inner content */\n.fc-daygrid-day-frame,\n.fc-daygrid-day-events,\n.fc-daygrid-event-harness {\n  /* for event top/bottom margins */\n}\n\n.fc-daygrid-day-frame:before,\n.fc-daygrid-day-events:before,\n.fc-daygrid-event-harness:before {\n  content: \"\";\n  clear: both;\n  display: table;\n}\n\n.fc-daygrid-day-frame:after,\n.fc-daygrid-day-events:after,\n.fc-daygrid-event-harness:after {\n  content: \"\";\n  clear: both;\n  display: table;\n}\n\n.fc .fc-daygrid-body {\n  /* a <div> that wraps the table */\n  position: relative;\n  z-index: 1;\n  /* container inner z-index's because <tr>s can't do it */\n}\n\n.fc .fc-daygrid-day.fc-day-today {\n  background-color: rgba(255, 220, 40, 0.15);\n  background-color: var(--fc-today-bg-color, rgba(255, 220, 40, 0.15));\n}\n\n.fc .fc-daygrid-day-frame {\n  position: relative;\n  min-height: 100%;\n  /* seems to work better than `height` because sets height after rows/cells naturally do it */\n}\n\n.fc {\n  /* cell top */\n}\n\n.fc .fc-daygrid-day-top {\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.fc .fc-day-other .fc-daygrid-day-top {\n  opacity: 0.3;\n}\n\n.fc {\n  /* day number (within cell top) */\n}\n\n.fc .fc-daygrid-day-number {\n  position: relative;\n  z-index: 4;\n  padding: 4px;\n}\n\n.fc {\n  /* event container */\n}\n\n.fc .fc-daygrid-day-events {\n  margin-top: 1px;\n  /* needs to be margin, not padding, so that available cell height can be computed */\n}\n\n.fc {\n  /* positioning for balanced vs natural */\n}\n\n.fc .fc-daygrid-body-balanced .fc-daygrid-day-events {\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n\n.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events {\n  position: relative;\n  /* for containing abs positioned event harnesses */\n  min-height: 2em;\n  /* in addition to being a min-height during natural height, equalizes the heights a little bit */\n}\n\n.fc .fc-daygrid-body-natural {\n  /* can coexist with -unbalanced */\n}\n\n.fc .fc-daygrid-body-natural .fc-daygrid-day-events {\n  margin-bottom: 1em;\n}\n\n.fc {\n  /* event harness */\n}\n\n.fc .fc-daygrid-event-harness {\n  position: relative;\n}\n\n.fc .fc-daygrid-event-harness-abs {\n  position: absolute;\n  top: 0;\n  /* fallback coords for when cannot yet be computed */\n  left: 0;\n  /* */\n  right: 0;\n  /* */\n}\n\n.fc .fc-daygrid-bg-harness {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n}\n\n.fc {\n  /* bg content */\n}\n\n.fc .fc-daygrid-day-bg .fc-non-business {\n  z-index: 1;\n}\n\n.fc .fc-daygrid-day-bg .fc-bg-event {\n  z-index: 2;\n}\n\n.fc .fc-daygrid-day-bg .fc-highlight {\n  z-index: 3;\n}\n\n.fc {\n  /* events */\n}\n\n.fc .fc-daygrid-event {\n  z-index: 6;\n  margin-top: 1px;\n}\n\n.fc .fc-daygrid-event.fc-event-mirror {\n  z-index: 7;\n}\n\n.fc {\n  /* cell bottom (within day-events) */\n}\n\n.fc .fc-daygrid-day-bottom {\n  font-size: .85em;\n  margin: 2px 3px 0;\n}\n\n.fc .fc-daygrid-more-link {\n  position: relative;\n  z-index: 4;\n  cursor: pointer;\n}\n\n.fc {\n  /* week number (within frame) */\n}\n\n.fc .fc-daygrid-week-number {\n  position: absolute;\n  z-index: 5;\n  top: 0;\n  padding: 2px;\n  min-width: 1.5em;\n  text-align: center;\n  background-color: rgba(208, 208, 208, 0.3);\n  background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));\n  color: #808080;\n  color: var(--fc-neutral-text-color, #808080);\n}\n\n.fc {\n  /* popover */\n}\n\n.fc .fc-more-popover {\n  z-index: 8;\n}\n\n.fc .fc-more-popover .fc-popover-body {\n  min-width: 220px;\n  padding: 10px;\n}\n\n.fc-direction-ltr .fc-daygrid-event.fc-event-start,\n.fc-direction-rtl .fc-daygrid-event.fc-event-end {\n  margin-left: 2px;\n}\n\n.fc-direction-ltr .fc-daygrid-event.fc-event-end,\n.fc-direction-rtl .fc-daygrid-event.fc-event-start {\n  margin-right: 2px;\n}\n\n.fc-direction-ltr .fc-daygrid-week-number {\n  left: 0;\n  border-radius: 0 0 3px 0;\n}\n\n.fc-direction-rtl .fc-daygrid-week-number {\n  right: 0;\n  border-radius: 0 0 0 3px;\n}\n\n.fc-liquid-hack .fc-daygrid-day-frame {\n  position: static;\n  /* will cause inner absolute stuff to expand to <td> */\n}\n\n.fc-daygrid-event {\n  /* make root-level, because will be dragged-and-dropped outside of a component root */\n  position: relative;\n  /* for z-indexes assigned later */\n  white-space: nowrap;\n  border-radius: 3px;\n  /* dot event needs this to when selected */\n  font-size: .85em;\n  font-size: var(--fc-small-font-size, 0.85em);\n}\n\n/* --- the rectangle (\"block\") style of event --- */\n.fc-daygrid-block-event .fc-event-time {\n  font-weight: bold;\n}\n\n.fc-daygrid-block-event .fc-event-time,\n.fc-daygrid-block-event .fc-event-title {\n  padding: 1px;\n}\n\n/* --- the dot style of event --- */\n.fc-daygrid-dot-event {\n  display: flex;\n  align-items: center;\n  padding: 2px 0;\n}\n\n.fc-daygrid-dot-event .fc-event-title {\n  flex-grow: 1;\n  flex-shrink: 1;\n  min-width: 0;\n  /* important for allowing to shrink all the way */\n  overflow: hidden;\n  font-weight: bold;\n}\n\n.fc-daygrid-dot-event:hover,\n.fc-daygrid-dot-event.fc-event-mirror {\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.fc-daygrid-dot-event.fc-event-selected:before {\n  /* expand hit area */\n  top: -10px;\n  bottom: -10px;\n}\n\n.fc-daygrid-event-dot {\n  /* the actual dot */\n  margin: 0 4px;\n  box-sizing: content-box;\n  width: 0;\n  height: 0;\n  border: 4px solid #3788d8;\n  border: calc(var(--fc-daygrid-event-dot-width, 8px) / 2) solid var(--fc-event-border-color, #3788d8);\n  border-radius: 4px;\n  border-radius: calc(var(--fc-daygrid-event-dot-width, 8px) / 2);\n}\n\n/* --- spacing between time and title --- */\n.fc-direction-ltr .fc-daygrid-event .fc-event-time {\n  margin-right: 3px;\n}\n\n.fc-direction-rtl .fc-daygrid-event .fc-event-time {\n  margin-left: 3px;\n}\n\n/*\nA VERTICAL event\n*/\n.fc-v-event {\n  /* allowed to be top-level */\n  display: block;\n  border: 1px solid #3788d8;\n  border: 1px solid var(--fc-event-border-color, #3788d8);\n  background-color: #3788d8;\n  background-color: var(--fc-event-bg-color, #3788d8);\n}\n\n.fc-v-event .fc-event-main {\n  color: #fff;\n  color: var(--fc-event-text-color, #fff);\n  height: 100%;\n}\n\n.fc-v-event .fc-event-main-frame {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.fc-v-event .fc-event-time {\n  flex-grow: 0;\n  flex-shrink: 0;\n  max-height: 100%;\n  overflow: hidden;\n}\n\n.fc-v-event .fc-event-title-container {\n  /* a container for the sticky cushion */\n  flex-grow: 1;\n  flex-shrink: 1;\n  min-height: 0;\n  /* important for allowing to shrink all the way */\n}\n\n.fc-v-event .fc-event-title {\n  /* will have fc-sticky on it */\n  top: 0;\n  bottom: 0;\n  max-height: 100%;\n  /* clip overflow */\n  overflow: hidden;\n}\n\n.fc-v-event:not(.fc-event-start) {\n  border-top-width: 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.fc-v-event:not(.fc-event-end) {\n  border-bottom-width: 0;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.fc-v-event.fc-event-selected:before {\n  /* expand hit area */\n  left: -10px;\n  right: -10px;\n}\n\n.fc-v-event {\n  /* resizer (mouse AND touch) */\n}\n\n.fc-v-event .fc-event-resizer-start {\n  cursor: n-resize;\n}\n\n.fc-v-event .fc-event-resizer-end {\n  cursor: s-resize;\n}\n\n.fc-v-event {\n  /* resizer for MOUSE */\n}\n\n.fc-v-event:not(.fc-event-selected) .fc-event-resizer {\n  height: 8px;\n  height: var(--fc-event-resizer-thickness, 8px);\n  left: 0;\n  right: 0;\n}\n\n.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start {\n  top: -4px;\n  top: calc(var(--fc-event-resizer-thickness, 8px) / -2);\n}\n\n.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end {\n  bottom: -4px;\n  bottom: calc(var(--fc-event-resizer-thickness, 8px) / -2);\n}\n\n.fc-v-event {\n  /* resizer for TOUCH (when event is \"selected\") */\n}\n\n.fc-v-event.fc-event-selected .fc-event-resizer {\n  left: 50%;\n  margin-left: -4px;\n  margin-left: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n}\n\n.fc-v-event.fc-event-selected .fc-event-resizer-start {\n  top: -4px;\n  top: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n}\n\n.fc-v-event.fc-event-selected .fc-event-resizer-end {\n  bottom: -4px;\n  bottom: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n}\n\n.fc .fc-timegrid .fc-daygrid-body {\n  /* the all-day daygrid within the timegrid view */\n  z-index: 2;\n  /* put above the timegrid-body so that more-popover is above everything. TODO: better solution */\n}\n\n.fc .fc-timegrid-divider {\n  padding: 0 0 2px;\n  /* browsers get confused when you set height. use padding instead */\n}\n\n.fc .fc-timegrid-body {\n  position: relative;\n  z-index: 1;\n  /* scope the z-indexes of slots and cols */\n  min-height: 100%;\n  /* fill height always, even when slat table doesn't grow */\n}\n\n.fc .fc-timegrid-axis-chunk {\n  /* for advanced ScrollGrid */\n  position: relative;\n}\n\n.fc .fc-timegrid-axis-chunk>table {\n  position: relative;\n  z-index: 1;\n  /* above the now-indicator-container */\n}\n\n.fc .fc-timegrid-slots {\n  position: relative;\n  z-index: 1;\n}\n\n.fc .fc-timegrid-slot {\n  /* a <td> */\n  height: 1.5em;\n  border-bottom: 0;\n}\n\n.fc .fc-timegrid-slot:empty:before {\n  content: '\\00a0';\n  /* make sure there's at least an empty space to create height for height syncing */\n}\n\n.fc .fc-timegrid-slot-minor {\n  border-top-style: dotted;\n}\n\n.fc .fc-timegrid-slot-label-cushion {\n  display: inline-block;\n  white-space: nowrap;\n}\n\n.fc .fc-timegrid-slot-label {\n  vertical-align: middle;\n  /* vertical align the slots */\n}\n\n.fc {\n  /* slots AND axis cells (top-left corner of view including the \"all-day\" text) */\n}\n\n.fc .fc-timegrid-axis-cushion,\n.fc .fc-timegrid-slot-label-cushion {\n  padding: 0 4px;\n}\n\n.fc {\n  /* axis cells (top-left corner of view including the \"all-day\" text) */\n  /* vertical align is more complicated, uses flexbox */\n}\n\n.fc .fc-timegrid-axis-frame-liquid {\n  height: 100%;\n  /* will need liquid-hack in FF */\n}\n\n.fc .fc-timegrid-axis-frame {\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  /* vertical align */\n  justify-content: flex-end;\n  /* horizontal align. matches text-align below */\n}\n\n.fc .fc-timegrid-axis-cushion {\n  max-width: 60px;\n  /* limits the width of the \"all-day\" text */\n  flex-shrink: 0;\n  /* allows text to expand how it normally would, regardless of constrained width */\n}\n\n.fc-direction-ltr .fc-timegrid-slot-label-frame {\n  text-align: right;\n}\n\n.fc-direction-rtl .fc-timegrid-slot-label-frame {\n  text-align: left;\n}\n\n.fc-liquid-hack .fc-timegrid-axis-frame-liquid {\n  height: auto;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.fc .fc-timegrid-col.fc-day-today {\n  background-color: rgba(255, 220, 40, 0.15);\n  background-color: var(--fc-today-bg-color, rgba(255, 220, 40, 0.15));\n}\n\n.fc .fc-timegrid-col-frame {\n  min-height: 100%;\n  /* liquid-hack is below */\n  position: relative;\n}\n\n.fc-liquid-hack .fc-timegrid-col-frame {\n  height: auto;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.fc-media-screen .fc-timegrid-cols {\n  position: absolute;\n  /* no z-index. children will decide and go above slots */\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.fc-media-screen .fc-timegrid-cols>table {\n  height: 100%;\n}\n\n.fc-media-screen .fc-timegrid-col-bg,\n.fc-media-screen .fc-timegrid-col-events,\n.fc-media-screen .fc-timegrid-now-indicator-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.fc-media-screen .fc-timegrid-event-harness {\n  position: absolute;\n  /* top/left/right/bottom will all be set by JS */\n}\n\n.fc {\n  /* bg */\n}\n\n.fc .fc-timegrid-col-bg {\n  z-index: 2;\n  /* TODO: kill */\n}\n\n.fc .fc-timegrid-col-bg .fc-non-business {\n  z-index: 1;\n}\n\n.fc .fc-timegrid-col-bg .fc-bg-event {\n  z-index: 2;\n}\n\n.fc .fc-timegrid-col-bg .fc-highlight {\n  z-index: 3;\n}\n\n.fc .fc-timegrid-bg-harness {\n  position: absolute;\n  /* top/bottom will be set by JS */\n  left: 0;\n  right: 0;\n}\n\n.fc {\n  /* fg events */\n  /* (the mirror segs are put into a separate container with same classname, */\n  /* and they must be after the normal seg container to appear at a higher z-index) */\n}\n\n.fc .fc-timegrid-col-events {\n  z-index: 3;\n  /* child event segs have z-indexes that are scoped within this div */\n}\n\n.fc {\n  /* now indicator */\n}\n\n.fc .fc-timegrid-now-indicator-container {\n  bottom: 0;\n  overflow: hidden;\n  /* don't let overflow of lines/arrows cause unnecessary scrolling */\n  /* z-index is set on the individual elements */\n}\n\n.fc-direction-ltr .fc-timegrid-col-events {\n  margin: 0 2.5% 0 2px;\n}\n\n.fc-direction-rtl .fc-timegrid-col-events {\n  margin: 0 2px 0 2.5%;\n}\n\n.fc-timegrid-event-harness-inset .fc-timegrid-event,\n.fc-timegrid-event.fc-event-mirror {\n  box-shadow: 0px 0px 0px 1px #fff;\n  box-shadow: 0px 0px 0px 1px var(--fc-page-bg-color, #fff);\n}\n\n.fc-timegrid-event {\n  /* events need to be root */\n  font-size: .85em;\n  font-size: var(--fc-small-font-size, 0.85em);\n  border-radius: 3px;\n}\n\n.fc-timegrid-event .fc-event-main {\n  padding: 1px 1px 0;\n}\n\n.fc-timegrid-event .fc-event-time {\n  white-space: nowrap;\n  font-size: .85em;\n  font-size: var(--fc-small-font-size, 0.85em);\n  margin-bottom: 1px;\n}\n\n.fc-timegrid-event-condensed .fc-event-main-frame {\n  flex-direction: row;\n  overflow: hidden;\n}\n\n.fc-timegrid-event-condensed .fc-event-time:after {\n  content: '\\00a0-\\00a0';\n  /* dash surrounded by non-breaking spaces */\n}\n\n.fc-timegrid-event-condensed .fc-event-title {\n  font-size: .85em;\n  font-size: var(--fc-small-font-size, 0.85em);\n}\n\n.fc-media-screen .fc-timegrid-event {\n  position: absolute;\n  /* absolute WITHIN the harness */\n  top: 0;\n  bottom: 1px;\n  /* stay away from bottom slot line */\n  left: 0;\n  right: 0;\n}\n\n.fc {\n  /* line */\n}\n\n.fc .fc-timegrid-now-indicator-line {\n  position: absolute;\n  z-index: 4;\n  left: 0;\n  right: 0;\n  border-style: solid;\n  border-color: red;\n  border-color: var(--fc-now-indicator-color, red);\n  border-width: 1px 0 0;\n}\n\n.fc {\n  /* arrow */\n}\n\n.fc .fc-timegrid-now-indicator-arrow {\n  position: absolute;\n  z-index: 4;\n  margin-top: -5px;\n  /* vertically center on top coordinate */\n  border-style: solid;\n  border-color: red;\n  border-color: var(--fc-now-indicator-color, red);\n}\n\n.fc-direction-ltr .fc-timegrid-now-indicator-arrow {\n  left: 0;\n  /* triangle pointing right. TODO: mixin */\n  border-width: 5px 0 5px 6px;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n}\n\n.fc-direction-rtl .fc-timegrid-now-indicator-arrow {\n  right: 0;\n  /* triangle pointing left. TODO: mixin */\n  border-width: 5px 6px 5px 0;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n}\n\n:root {\n  --fc-list-event-dot-width: 10px;\n  --fc-list-event-hover-bg-color: #f5f5f5;\n}\n\n.fc-theme-standard .fc-list {\n  border: 1px solid #ddd;\n  border: 1px solid var(--fc-border-color, #ddd);\n}\n\n.fc {\n  /* message when no events */\n}\n\n.fc .fc-list-empty {\n  background-color: rgba(208, 208, 208, 0.3);\n  background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* vertically aligns fc-list-empty-inner */\n}\n\n.fc .fc-list-empty-cushion {\n  margin: 5em 0;\n}\n\n.fc {\n  /* table within the scroller */\n  /* ---------------------------------------------------------------------------------------------------- */\n}\n\n.fc .fc-list-table {\n  width: 100%;\n  border-style: hidden;\n  /* kill outer border on theme */\n}\n\n.fc .fc-list-table tr>* {\n  border-left: 0;\n  border-right: 0;\n}\n\n.fc .fc-list-sticky .fc-list-day>* {\n  /* the cells */\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  background: #fff;\n  background: var(--fc-page-bg-color, #fff);\n  /* for when headers are styled to be transparent and sticky */\n}\n\n.fc .fc-list-table th {\n  padding: 0;\n  /* uses an inner-wrapper instead... */\n}\n\n.fc .fc-list-table td,\n.fc .fc-list-day-cushion {\n  padding: 8px 14px;\n}\n\n.fc {\n  /* date heading rows */\n  /* ---------------------------------------------------------------------------------------------------- */\n}\n\n.fc .fc-list-day-cushion:after {\n  content: \"\";\n  clear: both;\n  display: table;\n  /* clear floating */\n}\n\n.fc-theme-standard .fc-list-day-cushion {\n  background-color: rgba(208, 208, 208, 0.3);\n  background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));\n}\n\n.fc-direction-ltr .fc-list-day-text,\n.fc-direction-rtl .fc-list-day-side-text {\n  float: left;\n}\n\n.fc-direction-ltr .fc-list-day-side-text,\n.fc-direction-rtl .fc-list-day-text {\n  float: right;\n}\n\n/* make the dot closer to the event title */\n.fc-direction-ltr .fc-list-table .fc-list-event-graphic {\n  padding-right: 0;\n}\n\n.fc-direction-rtl .fc-list-table .fc-list-event-graphic {\n  padding-left: 0;\n}\n\n.fc .fc-list-event.fc-event-forced-url {\n  cursor: pointer;\n  /* whole row will seem clickable */\n}\n\n.fc .fc-list-event:hover td {\n  background-color: #f5f5f5;\n  background-color: var(--fc-list-event-hover-bg-color, #f5f5f5);\n}\n\n.fc {\n  /* shrink certain cols */\n}\n\n.fc .fc-list-event-graphic,\n.fc .fc-list-event-time {\n  white-space: nowrap;\n  width: 1px;\n}\n\n.fc .fc-list-event-dot {\n  display: inline-block;\n  box-sizing: content-box;\n  width: 0;\n  height: 0;\n  border: 5px solid #3788d8;\n  border: calc(var(--fc-list-event-dot-width, 10px) / 2) solid var(--fc-event-border-color, #3788d8);\n  border-radius: 5px;\n  border-radius: calc(var(--fc-list-event-dot-width, 10px) / 2);\n}\n\n.fc {\n  /* reset <a> styling */\n}\n\n.fc .fc-list-event-title a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.fc {\n  /* underline link when hovering over any part of row */\n}\n\n.fc .fc-list-event.fc-event-forced-url:hover a {\n  text-decoration: underline;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
